import { Injectable } from '@angular/core';
import { RequestMethod } from '@angular/http';
import { CustomHttp } from 'app/common/http/custom.http';
import { RequestConfig } from 'app/shared/rest/rest.request';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OfflineOperationsActionsService {
  private VALIDATE_MODE_APP_OPERATIONS = new RequestConfig('GANTT001', 'application/json', true, RequestMethod.Get, '/bitacoraOperacionesOffline');
  private CHANGE_MODE_APP_OPERATIONS = new RequestConfig('GANTT001', 'application/json', true, RequestMethod.Post, '/bitacoraOperacionesOffline');

  constructor(private http: CustomHttp) { }

  public validateModeApp(): Observable<any> {
    return this.http.sendRequestToUrl(environment.Mega_url, this.VALIDATE_MODE_APP_OPERATIONS)
      .pipe(
        map((response: any) => (response.json())),
        catchError((error) => {
          try {
            error = error.json();
          } catch (e) { }
          return throwError(error);
        })
      );
  }
  public changeModeApp(body: ChangeModeApp): Observable<any> {
    return this.http.sendRequestToUrl(environment.Mega_url, this.CHANGE_MODE_APP_OPERATIONS, body)
      .pipe(
        map((response: any) => (response.json())),
        catchError((error) => {
          try {
            error = error.json();
          } catch (e) { }
          return throwError(error);
        })
      );
  }
}
@Injectable()
export class ChangeModeApp {
  estado_apk: boolean;
  idUsuario: string;
}